import AccountTreeIcon from "@mui/icons-material/AccountTree";
import CategoryIcon from "@mui/icons-material/Category";
import Divider from "@mui/material/Divider";
import Grid from "@mui/material/Grid";
import { useEffect, useState } from "react";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

// const machine = '../images/matchine-icon.png';
import NoteIcon from "@mui/icons-material/Note";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Chip,
  Collapse,
  TextField,
  Zoom,
} from "@mui/material";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography/Typography";
import clsx from "clsx";
import QrcodeIcon from "mdi-react/QrcodeIcon";
import { connect, useStore } from "react-redux";
import { Link } from "react-router-dom";
import IconText from "../../../../components/IconText";
import NotificationCardItem from "../../../../components/NotificationCardItem";
import { Theme247 } from "../../../../styles/Theme247";
import { ApplyStyle as _s } from "../../../../utils/ApplyStyle";
import { useAccountMode, withCurrentAccountPrefix } from "../../../../utils/accountMode";

import { updatemachine, getSingleMachine } from "../../../../actions/machines";

import { History, Label } from "@mui/icons-material";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import {
  Document,
  Image,
  PDFDownloadLink,
  Page,
  StyleSheet,
  Text,
  View,
} from "@react-pdf/renderer";
import moment from "moment";
import QRCode from "qrcode";
import { Lightbox } from "react-modal-image";
import { makeStyles } from "tss-react/mui";
import logo247UpTime from "../../../../assets/247uptime-logo.svg";
import { canUserPerformAction } from "../../../../shared-functions/userrights";
import QrCodeComponent from "./components/QRcode";
import logo from "./logo.png";
import QrCode from "./qr-code.png";
import { setItem } from "../../../../utils/DataProtection";

export default connect(
  ({ machines, isadmin, profile }) => ({ machines, isadmin, profile }),
  { updatemachine, getSingleMachine }
)((props) => {
  /*
   * States, Constants
   */
  const i18n = useStore().getState().i18n;
  const store = useStore().getState();
  const [isCollapsedInfoVisible] = useState(false);

    const { theme, prefixPath } = useAccountMode();

  const [note, setNote] = useState("");

  const [isOpen, setisOpen] = useState(false);
  const [large, setlarge] = useState("");
  const [isUrl, setIsUrl] = useState("");

  const [expanded, setExpanded] = useState(true);

  const onImgClick = (e, url) => {
    e.preventDefault();
    setisOpen(true);
    setlarge(url);
    setIsUrl(url);
  };
  useEffect(() => {
    if (isUrl) setlarge(isUrl);
  }, [isUrl]);

  useEffect(() => {
    setNote(props.machines?.equipment?.memo);
  }, []);

  const closeLightbox = () => {
    setisOpen(false);
  };

  const nodeid =
    props.from == "mb" ? props.nodeid : props.machines?.equipment?.nodeid;
  const name =
    props.from == "mb" ? props.srno : props.machines?.equipment?.name;
  const model =
    props.machines?.equipment?.hasequipmenttype &&
    props.machines?.equipment?.hasequipmenttype[0]?.equipmenttype?.model;
  const brand =
    props.machines?.equipment?.hasequipmenttype &&
    props.machines?.equipment?.hasequipmenttype[0]?.equipmenttype
      ?.isequipmenttypeof[0]?.brand?.name;

  /*
   * Styles
   */
  const useStyles = makeStyles()(() => ({
    machineDetailsContainer: {
      padding: "28px 0px 28px 24px",
    },
    collapseDetails: {
      paddingTop: 16,
    },
    machineDetails: {
      display: "flex",
      flexDirection: "row",
    },
    sectionButtonFooter: {
      ...Theme247.sectionButtonFooter,
    },
    iconTextLink: {
      cursor: "pointer",

      "& .MuiTypography-caption": {
        color: Theme247.palette.secondary.main,
      },

      "& .mdi-icon, & .MuiSvgIcon-root": {
        width: "1rem",
        height: "1rem",
        transform: "translateY(0.15em)",
      },
    },
    optionsButtonContainer: {
      marginTop: -12,
      marginLeft: 24,
    },
    itemcardGridSection: {
      ...Theme247.itemcardGridSection,
      marginBottom: 0,
    },
    itemcardGridItem: {
      ...Theme247.itemcardGridItem,
      "&:nth-of-type(odd)": {
        marginRight: 24,
      },
    },
    itemcardButtonFooter: {
      ...Theme247.itemcardButtonFooter,

      "& button": {
        minWidth: 150,
        marginLeft: 24,

        "&:first-of-type": {
          marginLeft: 0,
        },
      },
    },
  }));
  const { classes } = useStyles();
  // Create styles
  const styles = StyleSheet.create({
    page: {
      flexDirection: "row",
      backgroundColor: "#E4E4E4",
    },
    section: {
      margin: 10,
      padding: 10,
      flexGrow: 1,
    },
  });
  /*
   * Functions
   */

  function handleNotificationClick(item) {
    setItem("notification-nodeid", item?.notification?.nodeid);
    setItem(
      "chatroomnodeid",
      item?.notification?.haschatroom?.[0].chatroom?.nodeid
    );
  }
  const equp_local = props.machines?.equipment;

  let equq_pool_local;
  if (
    props.machines?.equipment?.isequipmentof &&
    props.machines?.equipment?.isequipmentof[0]?.equipmentpool !== undefined
  ) {
    equq_pool_local =
      props.machines?.equipment?.isequipmentof &&
      props.machines?.equipment?.isequipmentof[0].equipmentpool;
  } else {
    equq_pool_local =
      props.machines?.equipment?.isequipmentof &&
      props.machines?.equipment?.isequipmentof[0].area;
  }

  const [openDialog, setopenDialog] = useState(false);

  const handleCloseDialog = () => {
    setopenDialog(false);
  };

  const styless = StyleSheet.create({
    body: {
      paddingTop: 35,
      paddingBottom: 65,
      paddingHorizontal: 35,
    },
    subtitle: {
      fontSize: 18,
      margin: 12,
    },
    image: {
      marginVertical: 10,
      marginHorizontal: 220,
      width: 100,
    },
    qrCode: {
      height: 300,
      width: 300,
      marginHorizontal: 120,
      marginVertical: 5,
    },
  });

  const MyDoc = () => (
    // <Document>
    //   <Page size="A4" style={styles.page}>
    //     <View>
    //       <Image src={logo} style={{ height: "auto", width: "100%" }} />
    //       <Image src={generateQR(nodeid)} style={{ height: 300, width: 300, marginLeft: 150, marginTop: 5 }} />
    //     </View>
    //     <View>
    //       <Text style={{ marginTop: 440, marginRight: 1050, backgroundColor: 'white',width:"100%" }}>
    //         {name}
    //       </Text>

    //       <Text style={{ marginTop: 30, marginRight: 1050, backgroundColor: 'white',width:"100%" }}>
    //         {brand}  {model}
    //       </Text>

    //     </View>
    //   </Page>
    // </Document>

    <Document>
      <Page style={styless.body}>
        <Image style={styless.image} src={logo} />

        <Image src={generateQR(nodeid)} style={styless.qrCode} />

        <Text style={styless.subtitle}>{name}</Text>

        <Text style={styless.subtitle}>
          {brand} {model}
        </Text>
      </Page>
    </Document>
  );
  const generateQR = async (text) => {
    try {
      return await QRCode.toDataURL(text);
    } catch (err) {
      console.error(err);
    }
  };

  const handleSave = async () => {
    let editPayload = {
      lang: store.language,
      equipmentnodeid: props.machines?.equipment?.nodeid,
      memo: note,
    };
    await props.updatemachine(editPayload);

    setTimeout(function() {
      props.getSingleMachine(props.machines?.equipment?.nodeid);
    }, 2000);
  };

  return (
    <div>
      {isOpen && (
        <Lightbox
          large={large}
          alt={i18n.image_here}
          hideZoom={false}
          showRotate={true}
          onClose={closeLightbox}
        />
      )}
      <Grid container className={classes.machineDetailsContainer}>
        {props.from === "mb" ? (
          <>
            <Grid item xs={12} className={classes.machineDetails}>
              <>
                <ul className={_s(Theme247.iconTextList)}>
                  <li>
                    <IconText
                      icon={<History fontSize="small" />}
                      text={
                        "Baujahr:" + moment(Number(props.c_yr)).format("YYYY")
                      }
                    />
                  </li>
                  <li>
                    <IconText
                      icon={<Label fontSize="small" />}
                      text={"Seriennummer: " + props.srno}
                    />
                  </li>
                </ul>
                <img
                  src={QrCode}
                  onClick={() => {
                    /* TODO: QR */ setopenDialog(true);
                  }}
                  style={{ marginLeft: 707, cursor: "pointer" }}
                  alt="Click Here To QRCode"
                  width="54px"
                  height="54px"
                />
              </>
              <Divider orientation="horizontal" />
            </Grid>

            {/*  <Grid item xs={12} className={classes.machineDetails}>
              <Grid item xs={6}>
                <div className={_s(Theme247.sectionContentContainer)}>
                  <div className={_s(Theme247.innerSectionContainer)}>
                    <Typography variant="h1" component="h2">{i18n.customer_contact}</Typography>

                  </div>
                  <p>
                    Peter Gerlacher<br />
                    <a href="mailto:peter.gerlacher@fabrik.de">peter.gerlacher@fabrik.de</a><br />
                    Tel. <a href="tel:004989123445">+49 89 / 1234 5689 03</a>
                  </p>
                </div>
              </Grid>

            </Grid> */}
          </>
        ) : (
          <>
            <Grid item xs={12} className={classes.machineDetails}>
              {/*  <ul className={_s(Theme247.iconTextList)}>
                <li><IconText icon={<CategoryIcon />} text={"Fräsmaschine"} /></li>
                <li><IconText icon={<AccountTreeIcon />} text={"Spanende Fertigung"} /></li>
              </ul>

              <Divider orientation="vertical" className={_s(Theme247.detailsDivider)} /> */}

              {/* <ul className={_s(Theme247.iconTextList)}> */}
              {/* <li><a onClick={() => {  setopenDialog(true)
                }}><IconText icon={<QrcodeIcon />} text={i18n.show_qr_code} className={classes.iconTextLink} /></a></li> */}
              {/* </ul> */}

              <Chip
                variant="outlined"
                size="small"
                className="MO_chips"
                icon={<QrcodeIcon />}
                label={i18n.show_qr_code}
                onClick={() => {
                  setopenDialog(true);
                }}
              />

              <Divider
                orientation="vertical"
                className={_s(Theme247.detailsDivider)}
              />

              <Chip
                variant="outlined"
                size="small"
                className="MO_chips"
                icon={<NoteIcon />}
                label={i18n.show_type_plate}
                onClick={(e) => {
                  onImgClick(e, props.machines.equipment?.typenameplate?.url);
                }}
              />

              <ul className={_s(Theme247.iconTextList)}>
                {/* <li><a onClick={(e) => {
                  onImgClick(e, props.machines.equipment?.typenameplate?.url) 
                }}><IconText icon={<NoteIcon />} text={i18n.show_type_plate} className={classes.iconTextLink} /></a></li> */}
              </ul>

              {/* <Divider orientation="vertical" className={_s(Theme247.detailsDivider)} />

              <ul className={_s(Theme247.iconTextList)}>
                <li><a onClick={toggleCollapsedInformation}><IconText icon={null} text={i18n.show_more_info} right={
                  isCollapsedInfoVisible ? <ExpandLessIcon /> : <ExpandMoreIcon />
                } className={classes.iconTextLink} /></a></li>
              </ul> */}
              {<></>}
            </Grid>

            <Collapse in={isCollapsedInfoVisible}>
              <Grid
                item
                xs={12}
                className={clsx(
                  classes.machineDetails,
                  classes.collapseDetails
                )}
              >
                <ul className={_s(Theme247.iconTextList)}>
                  <li>
                    <IconText
                      icon={<CategoryIcon />}
                      text={"further information to be defined"}
                    />
                  </li>
                  <li>
                    <IconText
                      icon={<AccountTreeIcon />}
                      text={"further information to be defined"}
                    />
                  </li>
                </ul>
              </Grid>
            </Collapse>

            <Divider orientation="horizontal" />

            <div
              className={_s(Theme247.sectionContentContainer)}
              style={{ display: "flex", flexFlow: "wrap", marginLeft: -26 }}
            >
              <Typography variant="h1" component="h2">
                {i18n.heading_latest_notifications}
              </Typography>

              <Grid
                container
                spacing={3}
                direction="row"
                justifyContent="space-between"
              >
                <Grid item xs={12}>
                  <div className={_s(Theme247.itemcardGrid)}>
                    <div className={classes.itemcardGridSection}>
                      {props.machines?.equipment?.hasnotification?.length >
                      0 ? (
                        canUserPerformAction(
                          props.profile?.features?.notification,
                          "read"
                        ) &&
                        props.machines?.equipment?.hasnotification?.map(
                          (x, key) => {
                            return Number(x?.notification?.status) < 2 ? (
                              <div
                                key={key}
                                className={classes.itemcardGridItem}
                              >
                                <Link
                                  to={withCurrentAccountPrefix("/notification-details")}
                                  state={{
                                    nodeid: x?.notification?.nodeid,
                                    equipmentNodeId:
                                      props.machines?.equipment?.nodeid,
                                    from: "overview",
                                   
                                  }}
                                  onClick={() => handleNotificationClick(x)}
                                >
                                  <NotificationCardItem data={x}  equipment={props.machines?.equipment} />
                                </Link>
                              </div>
                            ) : (
                              ""
                            );
                          }
                        )
                      ) : (
                        <Typography
                          variant="body1"
                          style={{ color: "#C9C6C5" }}
                        >
                          {i18n.empty_notifications}
                        </Typography>
                      )}

                      {canUserPerformAction(
                        props.profile?.features?.notification,
                        "create"
                      ) && (
                        <div className={classes.itemcardButtonFooter}>
                          <Link
                            to={withCurrentAccountPrefix("/edit-notification")}
                            state={{
                              notification: "",
                              equip: equp_local,
                              equip_pool: equq_pool_local,
                              date: "",
                              time: "",
                              pageType: "add",
                              from: "machine",
                            }}
                          >
                            <Button variant="contained" color="primary">
                              {i18n.new_issue}
                            </Button>
                          </Link>

                          {!expanded ? (
                            <div style={{ height: "30px" }}></div>
                          ) : (
                            ""
                          )}
                        </div>
                      )}

                      <Accordion
                        className="sigAccordian"
                        sx={{ width: "100%", border: "none" }}
                        expanded={expanded}
                        // expanded
                      >
                        <AccordionSummary
                          expandIcon={<ExpandMoreIcon />}
                          aria-controls="panel1-content"
                          id="panel1-header"
                          onClick={() => {
                            setExpanded(!expanded);
                          }}
                        >
                          <Typography sx={{ color: "#38748D" }} variant="h1">
                            {i18n.memo_field}
                          </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                          <Grid container spacing={3}>
                            {
                              <>
                                <Grid item xs={12}>
                                  <TextField
                                    multiline
                                    rows="3"
                                    onChange={(e) => {
                                      setNote(e.target.value);
                                    }}
                                    placeholder={i18n.enter_memo}
                                    className={clsx(
                                      _s(Theme247.inputField),
                                      " notizen_textarea"
                                    )}
                                    value={note}
                                    sx={{ marginBottom: "0px" }}
                                  />
                                </Grid>
                              </>
                            }
                          </Grid>
                        </AccordionDetails>
                      </Accordion>

                      <div className={classes.itemcardButtonFooter}>
                        <Button
                          variant="contained"
                          color="primary"
                          onClick={handleSave}
                          disabled={note === "" || note === null || props.machines?.equipment?.memo === note}
                        >
                          {i18n.save}
                        </Button>
                      </div>
                    </div>
                  </div>
                </Grid>
              </Grid>
            </div>
          </>
        )}
      </Grid>

      {/* 
      <Divider orientation="horizontal" />

      <Grid container direction="row">
        <Grid item xs={6}>
          <div className={_s(Theme247.sectionContentContainer)}>
            <div className={_s(Theme247.innerSectionContainer)}>
              <Typography variant="h1" component="h2">{i18n.heading_responsible}</Typography>
              <div className={_s(Theme247.sectionOptionsButton)}>
                <IconButton>
                  <EditIcon />
                </IconButton>
              </div>
            </div>
            <p>
              Peter Gerlacher<br />
              <a href="mailto:peter.gerlacher@fabrik.de">peter.gerlacher@fabrik.de</a><br />
              Tel. <a href="tel:004989123445">+49 89 / 1234 5689 03</a>
            </p>
          </div>
        </Grid>

        <Grid item xs={6}>
          <div className={_s(Theme247.sectionContentContainer)}>
            <div className={_s(Theme247.innerSectionContainer)}>
              <Typography variant="h1" component="h2">{i18n.heading_manufacturer_service}</Typography>
              <div className={_s(Theme247.sectionOptionsButton)}>
                <IconButton>
                  <EditIcon />
                </IconButton>
              </div>
            </div>
            <p>
              DMG Services GmbH<br />
              <a href="mailto:service@dmg.com">service@dmg.com</a><br />
              Tel. <a href="tel:004989123445">+49 89 / 1234 5689 03</a>
            </p>
          </div>
        </Grid>
      </Grid>
        */}

      <Dialog
        open={openDialog}
        sx={{ backdropFilter: "blur(4px)" }}
        onClose={() => {
          handleCloseDialog();
        }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        TransitionComponent={Zoom}
      >
        <DialogContent dividers className="QR_dialogContent">
          {/* <Typography gutterBottom>
            Please Download QR-Code
          </Typography> */}

          <div className="bxShadow qrCode_Wrapper">
            <div className="qrCode">
              <QrCodeComponent nodeid={nodeid} />
            </div>
            <div className="company">
              <div className="image">
                <img src={theme.logo} alt="company-logo" />
              </div>
              <div className="content">
                <div>
                  {props.machines?.equipment?.name &&
                    props.machines?.equipment?.name}
                </div>
                <div>
                  <span className={_s(Theme247.typography.regular)}>
                    {props.machines?.equipment?.hasequipmenttype &&
                      props.machines?.equipment?.hasequipmenttype[0]
                        ?.equipmenttype?.isequipmenttypeof[0]?.brand?.name}

                    <em style={{ marginLeft: 5 }}>
                      {props.machines?.equipment?.hasequipmenttype &&
                        props.machines?.equipment?.hasequipmenttype[0]
                          ?.equipmenttype?.model}
                    </em>
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div className="qrLink">
            <PDFDownloadLink
              document={<MyDoc />}
              fileName={name + "-QRCode.pdf"}
            >
              {({ loading }) =>
                loading ? "Loading document..." : "Download as PDF"
              }
            </PDFDownloadLink>
          </div>
        </DialogContent>
        {/* <DialogActions>
          <PDFDownloadLink document={<MyDoc />} fileName={name + '-QRCode.pdf'}>
            {({ blob, url, loading, error }) => (loading ? 'Loading document...' : 'Download now!')}
          </PDFDownloadLink>
        </DialogActions> */}
      </Dialog>
    </div>
  );
});
